import * as React from "react"
import Img from "gatsby-image"
import { css } from "@emotion/react"
import { rhythm } from "../utils/typography"
import { graphql } from "gatsby"

export const BookFragment = graphql`
    fragment BookFragment on ContentfulAmazonBooks {
        text: childContentfulAmazonBooksTextLinkTextNode {
            f:fields {
                title
                link
            }
        }
        img:childContentfulAmazonBooksBildLinkTextNode {
            l:localAmazonBookImage {
                c:childImageSharp {
                    fixed(width: 130, height: 130, fit: CONTAIN, background: "rgba(255,255,255,1)" ) {
                        ...GatsbyImageSharpFixed_withWebp
                    }
                }
            }
        }
    }
`

export interface IBookFragment {
  text: {
    f: {
      title: string;
      link: string;
    };
  },
  img: {
    l: {
      c: {
        fixed: any;
      }
    }
  }
}

type Props = {
  books: IBookFragment[]
}

const Books = ({ books }: Props) => {
  return (
    <section css={css`
     margin-bottom: ${rhythm(2)}
    `}>
      <h2>Bücher zur Tour</h2>
      {books.map((book: IBookFragment) => (
        <div key={book.text.f.title} css={css`
          box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12);
          display:flex;
          padding-right: ${rhythm(0.5)};
          margin-bottom: ${rhythm(0.5)};
          @media screen and (min-width: 769px) {
            align-items: center;
            margin-bottom: ${rhythm(0.5)};
          }
        `}>
          <div css={css`
              width: 150px;
              margin: ${rhythm(0.25)} 0 ${rhythm(0.25)}  ${rhythm(0.5)};
            `}>
            <Img fixed={book.img.l?.c?.fixed}/>
          </div>
          <a
            css={css`
              flex-shrink: 2;
              margin-left:${rhythm(0.5)}`
            }
            className="link__external"
            rel="noopener noreferrer"
            target="_blank"
            href={book.text.f.link}>{book.text.f.title}</a>
        </div>
      ))}
    </section>
  )
}

export default React.memo(Books)
